/** @file Dopesheet colours and font, read once from the ui-kit tokens (--p2-*) of the panel element. */

/** Canvas fill/stroke styles for the dopesheet. */
export interface DopePalette {
  bg: string;
  raised: string;
  shade: string;
  line: string;
  fg: string;
  muted: string;
  accent: string;
  accentSoft: string;
  playhead: string;
  font: string;
}

/** `read` returns a CSS custom property (getComputedStyle(el).getPropertyValue in the panel). */
export function dopePalette(read: (name: string) => string): DopePalette {
  const v = (name: string): string => read(name).trim();
  return {
    bg: v('--p2-bg'), raised: v('--p2-bg-raised'), shade: v('--p2-bg-input'), line: v('--p2-border'),
    fg: v('--p2-fg'), muted: v('--p2-fg-muted'), accent: v('--p2-accent'), accentSoft: v('--p2-accent-soft'),
    playhead: v('--p2-animate'), font: `${v('--p2-font-size')} ${v('--p2-font-mono')}`,
  };
}
